export const clientId = import.meta.env.VITE_B2C_CLIENT_ID ?? 'b1605922-48fa-4225-bc69-a98e4e1251fb';
export const redirectUri = import.meta.env.VITE_REDIRECT_URI ?? 'http://localhost:3000';
export const basePath = import.meta.env.VITE_BASE_PATH ?? '/us';
export const fixed = import.meta.env.VITE_API_BASE ?? 'https://watchtower-develop.ab-inbev.com/api/';
export const AUTH_TOKEN_KEY = 'Auth_token';
export const b2cSignInAuthority = import.meta.env.VITE_B2C_SIGNIN_AUTHORITY;
export const b2cScope =
  import.meta.env.VITE_B2C_SCOPE ?? 'https://CommercialWholesalerB2C.onmicrosoft.com/beerforce-api/user.read';
export const b2cKnownAuthority = import.meta.env.VITE_B2C_KNOWN_AUTHORITY ?? 'commercialwholesalerb2c.b2clogin.com';

export const WSLR_NR_LABEL = 'WSLR NR';
export const WSLR_NET_REVENUE_LABEL = 'WSLR Net Revenue';
export const WSLR_REVENUE_LABEL = 'WSLR Revenue';

const WSLR_REVENUE_LABELS = {
  NR: WSLR_NR_LABEL,
  'Net Revenue': WSLR_NET_REVENUE_LABEL,
  Revenue: WSLR_REVENUE_LABEL,
} as const;

export const formatWslrRevenueLabel = (label: string) =>
  WSLR_REVENUE_LABELS[label as keyof typeof WSLR_REVENUE_LABELS] ?? label;
